(function(){
  // KAI Shop by Benefit. Kviz je odstranjen (odlocitev stranke, 12. 8. 2026).
  // Uporablja MALOPRODAJNE variante, NE lander produkta 10948564877655 - sicer se
  // kai-gift-auto.js ugasne (LANDER_PIDS) in darila tiho odpadejo.

  // Barve okusov, iste kot v kai-buybox-data.js. Kljuc je handle izdelka.
  var COL={
    'sea-moss-gel-raspberry':'#C43B5B','tropical-glow':'#F2913D',
    'sea-moss-gel-ginger-boost':'#D4820A','sea-moss-gel-berry-magic':'#D44050',
    'sea-moss-gel-mango':'#E8A820','sea-moss-gel-the-og':'#2E7D6B',
    'sea-moss-gel-passion-fruit-preorder':'#C17D3B','blueberry-sea-moss-gel-vegan':'#6B4E9E',
    'strawberry-vanilla-limited-edition':'#D4607A','apple-pie-vegan-limited-edition':'#C8854A',
    'blue-spirulina-sea-moss-gel':'#1E6B9E','peach-collagen-peptides':'#E8987A',
    'cranberry-probiotic-gut-support':'#9E2B45'
  };

  function boot(){
    var GELS=[];
    try{
      var raw=document.getElementById('kb-gels');
      if(raw) GELS=JSON.parse(raw.textContent||'[]');
    }catch(e){}
    var BY={}; GELS.forEach(function(g){ BY[g.h]=g; });

    function post(items){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',
        'X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})});
    }
    function refresh(){ ['cart:refresh','cart:change','cart:updated'].forEach(function(n){
      try{ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); }catch(e){} }); }

    function openDrawer(){
      try{
        var d=document.getElementById('cart-drawer');
        if(d){
          if(typeof d.show==='function'){ d.show(); return true; }
          if(typeof d.open==='function'){ d.open(); return true; }
        }
        var t=document.querySelector('[aria-controls="cart-drawer"],[data-drawer-target="cart-drawer"],a[href="#cart-drawer"]');
        if(t){ t.click(); return true; }
        var c=document.querySelector('a[href$="/cart"],a[href*="/cart"]');
        if(c){ c.click(); return true; }
      }catch(e){}
      return false;
    }

    // --- izbirnik okusov: vstavi pikice na kartice, ki so sea moss gel ---
    if(GELS.length){
      [].slice.call(document.querySelectorAll('.kb-card[data-handle]')).forEach(function(card){
        if(!BY[card.getAttribute('data-handle')]) return;
        var box=card.querySelector('.kb-cb'); if(!box) return;
        var lab=document.createElement('p');
        lab.className='kb-flavn';
        lab.innerHTML='<b>'+GELS.length+' flavours</b> - pick yours';
        var row=document.createElement('div');
        row.className='kb-flav';
        GELS.forEach(function(g){
          var d=document.createElement('button');
          d.type='button'; d.className='kb-fd'; d.title=g.t;
          d.setAttribute('aria-label',g.t);
          d.setAttribute('data-h',g.h);
          d.style.background=COL[g.h]||'#C6D0DA';
          if(g.h===card.getAttribute('data-handle')) d.classList.add('on');
          row.appendChild(d);
        });
        var h4=box.querySelector('h4');
        box.insertBefore(row,h4.nextSibling);
        box.insertBefore(lab,row);
      });
    }

    document.addEventListener('click',function(e){
      // preklop okusa
      var dot=e.target.closest('.kb-fd');
      if(dot){
        var card=dot.closest('.kb-card'); if(!card) return;
        var g=BY[dot.getAttribute('data-h')]; if(!g) return;
        var img=card.querySelector('.kb-cim img');
        if(img&&g.img){ img.src=g.img; img.alt=g.t; }
        var a=card.querySelector('.kb-cb h4 a');
        if(a){ a.textContent=g.t; a.href=g.u; }
        var im=card.querySelector('a.kb-cim');
        if(im){ im.href=g.u; im.setAttribute('aria-label',g.t); }
        var pr=card.querySelector('.kb-price'); if(pr) pr.textContent=g.p;
        var add=card.querySelector('.kb-add');
        if(add){
          add.setAttribute('data-vid',g.v);
          add.disabled=!g.a;
          add.textContent=g.a?'Add to cart':'Sold out';
        }
        card.setAttribute('data-handle',g.h);
        [].slice.call(card.querySelectorAll('.kb-fd')).forEach(function(o){ o.classList.remove('on'); });
        dot.classList.add('on');
        return;
      }
      // dodaj v kosarico
      var b=e.target.closest('.kb-add'); if(!b) return;
      var vid=parseInt(b.getAttribute('data-vid'),10); if(!vid) return;
      var t=b.textContent; b.disabled=true; b.textContent='Adding...';
      post([{id:vid,quantity:1}]).then(function(){
        b.textContent='Added'; refresh();
        setTimeout(openDrawer,450);
        setTimeout(function(){ b.disabled=false; b.textContent=t; },1800);
      }).catch(function(){ b.disabled=false; b.textContent=t; });
    });

    // --- lepljiva vrstica ---
    var rail=document.querySelector('.kb-rail'), tiles=document.querySelector('.kb-tiles');
    function topOffset(){
      var b=0;
      [].slice.call(document.querySelectorAll('header,.header,#header,[id*="header-group"],[class*="header-group"]'))
        .forEach(function(el){
          if(el.closest('.kb')) return;
          var cs=window.getComputedStyle(el);
          if(cs.position!=='fixed'&&cs.position!=='sticky') return;
          var r=el.getBoundingClientRect();
          if(r.height>0&&r.top<=2&&r.bottom>b) b=r.bottom;
        });
      return Math.max(0,Math.round(b));
    }
    function placeRail(){ if(rail) rail.style.top=topOffset()+'px'; }

    if(rail&&tiles&&window.IntersectionObserver){
      placeRail();
      window.addEventListener('resize',placeRail);
      var links=[].slice.call(rail.querySelectorAll('a'));
      var bands=links.map(function(a){ return document.querySelector(a.getAttribute('href')); });
      new IntersectionObserver(function(en){ rail.classList.toggle('on',!en[0].isIntersecting); },
        {rootMargin:'-60px 0px 0px 0px'}).observe(tiles);
      window.addEventListener('scroll',function(){
        placeRail();
        var y=window.scrollY+190,c=0;
        bands.forEach(function(b,i){ if(b&&b.offsetTop<=y) c=i; });
        links.forEach(function(a,i){ a.classList.toggle('act',i===c); });
      },{passive:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();